import * as accountsApi from '@/network/api/accounts.api.js'
import * as termsApi from '@/network/api/terms.api.js'

/** requests Accounts Balance
@return { promise } - Accounts Balance request
*/
export const requestAccountsBalances = async (context, payload) => {
    const res = await accountsApi.requestAccountsBalances(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_ACCOUNTS_BALANCE', data)
    }
    return res
}

/** Charge DP
@return { promise } - Term Account Reinforcement
*/
export const chargeDp = async (context, payload) => {
    const res = await termsApi.chargeDp(payload)
    return res
}

/** Clear charge states
@return { promise }
*/
export const clearChargeDPStates = async (context, payload) => {
    context.commit('CLEAR_CHARGE_DP_STATES')
}
